import type {RefObject} from 'react';
import {useEffect} from 'react';
import {useAppDispatch} from '@/hooks';
import {updateTimelineHeight} from '../timeline-reducer';

/**
 * Custom hook that tracks the timeline container height using ResizeObserver
 * and updates the Redux state accordingly.
 */
export function useTimelineHeightObserver(containerRef: RefObject<HTMLDivElement | null>): void {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        dispatch(updateTimelineHeight(entry.contentRect.height));
      }
    });

    resizeObserver.observe(container);

    return () => {
      resizeObserver.disconnect();
    };
  }, [containerRef, dispatch]);
}
